import { render, staticRenderFns } from "./flow-editor-model.vue?vue&type=template&id=45aacd35&"
import script from "./flow-editor-model.vue?vue&type=script&lang=js&"
export * from "./flow-editor-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports